import { currentRouteConfig } from './currentRouteConfig';
import type { RouteConfigExtended } from './types';

export default (routes: RouteConfigExtended[]) => currentRouteConfig(routes)?.tab;
